import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import { setSelectedNews } from 'src/store/news';

import { ROUTE } from 'src/constants';

import { CustomButton, CustomPagination, SectionCard } from 'src/components';

import { ReactComponent as Arrow } from 'src/assets/overall/Arrow.svg';
import './news.scss';

const cryptoNews = [
  {
    id: 1,
    image: 'https://placehold.co/150/0000FF/808080?text=Crypto+1',
    title: 'Bitcoin Hits All-Time High',
    created: '2024-07-28',
    description:
      "Bitcoin continues to break records as it reaches an all-time high, exceeding analysts' expectations. Experts attribute the growth to increased institutional adoption and a favorable macroeconomic environment. With more companies accepting Bitcoin as payment, the currency's utility is growing significantly. Investors remain bullish despite market volatility, citing its potential as a digital gold replacement.",
  },
  {
    id: 2,
    image: 'https://placehold.co/150/0000FF/808080?text=Crypto+2',
    title: 'Ethereum 2.0 Launches Successfully',
    created: '2024-08-15',
    description:
      'Ethereum 2.0 is finally here, marking a new era for the blockchain network. The transition to Proof of Stake has drastically reduced energy consumption and improved scalability. Developers are optimistic about the possibilities this upgrade brings, especially in the areas of DeFi and NFTs. The community celebrates this milestone as a step forward in the evolution of blockchain technology.',
  },
  {
    id: 3,
    image: 'https://placehold.co/150/0000FF/808080?text=Crypto+3',
    title: 'Regulatory Crackdown on Crypto Exchanges',
    created: '2024-09-13',
    description:
      'Governments worldwide are increasing scrutiny on cryptocurrency exchanges, citing concerns over money laundering and tax evasion. Major exchanges have responded by enhancing their compliance measures, including stricter KYC requirements. While some fear this could stifle innovation, others see it as a necessary step towards legitimizing the industry.',
  },
  {
    id: 4,
    image: 'https://placehold.co/150/0000FF/808080?text=Crypto+4',
    title: 'Solana Gains Momentum Among Developers',
    created: '2024-11-21',
    description:
      'Solana is rapidly gaining traction among developers due to its low fees and high transaction speeds. New projects are being launched daily on the platform, from DeFi protocols to NFT marketplaces. Analysts believe Solana could become a significant competitor to Ethereum, especially as it attracts more institutional investment.',
  },
  {
    id: 5,
    image: 'https://placehold.co/150/0000FF/808080?text=Crypto+5',
    title: "Dogecoin's Surprising Comeback",
    created: '2024-08-12',
    description:
      "Dogecoin has shocked the market with a massive comeback, fueled by renewed interest and celebrity endorsements. What started as a joke has now become a serious contender in the crypto space. Fans and investors alike are optimistic about Dogecoin's future, with many pointing to its growing use cases and active community.",
  },
  {
    id: 6,
    image: 'https://placehold.co/150/0000FF/808080?text=Crypto+6',
    title: 'Crypto Market Experiences Major Correction',
    created: '2024-10-10',
    description:
      'The cryptocurrency market has experienced a major correction, wiping out billions of dollars in market cap. Analysts view this as a healthy pullback after months of rapid growth. Investors are now looking for opportunities to buy the dip, while critics warn of the risks associated with such volatile markets.',
  },
  {
    id: 7,
    image: 'https://placehold.co/150/0000FF/808080?text=Crypto+7',
    title: 'DeFi Projects Show Strong Growth',
    created: '2024-09-06',
    description:
      'Decentralized finance (DeFi) projects are showing unprecedented growth, attracting billions in total value locked (TVL). Innovations in lending, borrowing, and yield farming are redefining traditional finance. Experts believe DeFi is at the forefront of the next financial revolution, despite regulatory uncertainties.',
  },
  {
    id: 8,
    image: 'https://placehold.co/150/0000FF/808080?text=Crypto+8',
    title: 'NFT Boom Continues in 2024',
    created: '2024-11-05',
    description:
      'The NFT boom shows no signs of slowing down as sales continue to break records. Artists and creators are flocking to blockchain platforms to mint their work, while collectors spend millions on digital assets. Some see NFTs as a speculative bubble, while others believe they represent the future of art and entertainment.',
  },
  {
    id: 9,
    image: 'https://placehold.co/150/0000FF/808080?text=Crypto+9',
    title: "Polkadot's Parachain Auction Success",
    created: '2024-10-11',
    description:
      "Polkadot's parachain auctions have been a resounding success, with multiple projects vying for slots on the network. This innovative approach allows for seamless interoperability between blockchains, a key feature in the Web3 ecosystem. Industry experts are keeping a close eye on Polkadot as it cements its position as a leader in blockchain innovation.",
  },
  {
    id: 10,
    image: 'https://placehold.co/150/0000FF/808080?text=Crypto+10',
    title: 'Cardano Partners with Major Institution',
    created: '2024-08-25',
    description:
      "Cardano has announced a groundbreaking partnership with a major institution, signaling growing adoption of its blockchain technology. The partnership aims to leverage Cardano's smart contract capabilities to solve real-world problems. This move is expected to boost Cardano's credibility and attract more developers to the platform.",
  },
];

export const News = () => {
  const { t } = useTranslation('news');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClickDetails = useCallback(
    (item) => () => {
      navigate(ROUTE.NEWS.VIEW_NEWS.replace(':id', item.id));
      dispatch(setSelectedNews(item));
    },
    [dispatch, navigate],
  );

  return (
    <div className="news">
      <SectionCard title={t('title')}>
        {cryptoNews.map((item) => (
          <div className="news__item" key={item.id}>
            <div className="news__item__image">
              <img src={item.image} alt={item.image} />
            </div>
            <div className="news__item__content">
              <div className="news__item__date">
                {moment(item.created).format('DD.MM.YYYY, HH:mm')}
              </div>
              <h4 className="news__item__title">{item.title}</h4>
              <div className="news__item__description">
                <span>{item.description}</span>
              </div>
              <div className="news__item__button">
                <CustomButton
                  title={t('more')}
                  icon={<Arrow />}
                  onClick={onClickDetails(item)}
                  iconPosition="right"
                />
              </div>
            </div>
          </div>
        ))}
      </SectionCard>

      <CustomPagination totalItems={cryptoNews.length} withSelect={false} />
    </div>
  );
};
